export const instructorProfile = {
  name: 'Shelendra Kumar',
  role: 'Engineering Leader · Udemy Instructor',
  udemyUrl: 'https://www.udemy.com/user/shelendra-5/',
  linkedinUrl: 'https://www.linkedin.com/in/shelendra-kumar-6342a777/',
  bio:
    'With 15 years of experience in software engineering, I help professionals build real-world skills in programming, automation testing, and generative AI. Through structured Udemy courses and hands-on practice websites, I focus on practical learning that prepares you for industry challenges.',
  experience: { value: '15+', label: 'Years in Software Engineering' },
  expertise: [
    'Programming',
    'Web Automation',
    'API Testing',
    'Generative AI',
    'Test Frameworks',
  ],
};
